import React from 'react';
import { Formik } from 'formik';
import { Grid, Form, Button, Divider } from 'semantic-ui-react';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Column } from 'components/Layout';
import getErrors from 'shared/lib/geterrors';
import GestioneCollaboratoreService from 'shared/services/rpc/gestione-collaboratore';

import { AsyncSelect } from '../../UI/AsyncSelect';
import { DatePicker } from '../../UI/DatePicker';

const DividerForm = () => <Column width={16}><Divider fitted style={{ marginLeft: -20, marginRight: -20 }} /></Column>;

const Handle = Slider.Handle;

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
      onMouseDown={(e) => { e.currentTarget.focus(); e.currentTarget.blur(); }} // Hack per evitare che i field che allineano i valori formik al blur non ritengano il valore
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

// TODO: Aggiungere proptypes corretti
handle.propTypes = {
  value: PropTypes.any,
  dragging: PropTypes.any,
  index: PropTypes.any,
};

export class ProfiloForm extends React.Component {
  state = {
    gruppi: [],
    labelProfilo: '',
  }

  render() {
    const props = this.props;
    return (
      <Grid style={{ paddingBottom: 15 }}>
        <Column width={16}>
          <Formik
            initialValues={{
              id: props.initialValues ? props.initialValues.id : '',
              percentualeOver: _.get(props, 'initialValues.percentualeOver') ? props.initialValues.percentualeOver : 0,
              dataInizioValidita: _.get(props, 'initialValues.dataInizioValidita') ? moment.unix(props.initialValues.dataInizioValidita) : '',
              dataFineValidita: _.get(props, 'initialValues.dataFineValidita') ? moment.unix(props.initialValues.dataFineValidita) : '',
              tutor: _.get(props, 'collaboratoreId') || '',
              tutee: _.get(props, 'initialValues.tutee') || '',
            }}
            validate={values => { // eslint-disable-line
              // same as above, but feel free to move this into a class method now.
              let errors = {}; // eslint-disable-line
            /* if (!values.email) {
                errors.email = 'Required';
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
              ) {
                errors.email = 'Invalid email address';
              }*/
              return errors;
            }}
            onSubmit={(
              values,
              { setSubmitting, setErrors /* setValues and other goodies */ } // eslint-disable-line
            ) => {
              setSubmitting(true);

              props.addAction(values).then( // As in prop catch error is handled and not thrown we have to verify status inside .then()
              (data) => {
                setSubmitting(false);
                if (data.status === 200 || data.status === 201 || !data.status) {
                  props.closeModal();
                } else {
                  const errorsObj = getErrors(data);
                  setSubmitting(false);
                  setErrors(errorsObj);
                }
              }
            );
              // props.closeModal();
            }}
            render={({
              values,
              errors,
              touched,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
              }) => (
                <Form autoComplete="off" onSubmit={handleSubmit} loading={isSubmitting}>
                  <Grid>
                    <Column width={16}>
                      {/* TODO: Passare le options */}
                      <AsyncSelect
                        loadOptions={() => GestioneCollaboratoreService.getTutorableOption(this.props.collaboratoreId)}
                        value={values.tutee}
                        onChange={(fieldName, data) => { setFieldValue(fieldName, data); }}
                        onBlur={setFieldTouched}
                        error={errors.tutee}
                        touched={touched.tutee}
                        name="tutee"
                        label="Tutee"
                      />
                    </Column>
                    <Column width={16} key="percentualeOverTutor">
                      <Form.Field>
                        <label htmlFor="slider">Percentuale over dovuta al tutor: {values.percentualeOver}%</label>
                        <Slider step={5} onAfterChange={(val) => setFieldValue('percentualeOver', val)} min={0} max={100} defaultValue={values.percentualeOver} handle={handle} />
                      </Form.Field>
                    </Column>
                    <Column width={16}>
                      <DatePicker touched={touched} errors={errors} value={values.dataInizioValidita} onChange={setFieldValue} name="dataInizioValidita" label="Inizio validità" startDate={moment()} openDirection="up" />
                    </Column>
                    <Column width={16}>
                      <DatePicker touched={touched} errors={errors} value={values.dataFineValidita} onChange={setFieldValue} name="dataFineValidita" label="Fine validità" startDate={moment()} openDirection="up" />
                    </Column>
                    <DividerForm />
                    <Column width={16} textAlign="center">
                      <Button disabled={isSubmitting} primary style={{ marginTop: 7 }}>
                        {props.initialValues && props.initialValues.id ? 'Modifica' : 'Aggiungi'}
                      </Button>
                    </Column>

                  </Grid>
                </Form>
              )}
          />
        </Column>
      </Grid>);
  }
}

export default ProfiloForm;

ProfiloForm.propTypes = {
  // initialValues: PropTypes.object,
  collaboratoreId: PropTypes.string,
};




// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/tuteeForm.js